<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Red Sox in the Hall of Fame</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">CONTENTS</p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><a href="#/Chapter01#C1">1.</a></td><td><a href="#/Chapter01#C1">Four Sox for the New Hall</a></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">The Gallery of Boston Stars Grows</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Yawkey’s Way</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Red Sox Plaque Parade Marches On</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">The Kid in Bronze</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">A New Cast of Legends</span></td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Yaz’s Impossible Dream Comes True</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Pedro Leads 21st-Century Lineup</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1625af72